import { InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";

export const silentTokenAcquire = async (
  instance: IPublicClientApplication
): Promise<boolean> => {
  try {
    console.log("Re-login attempt started");
    const account = instance.getAllAccounts()[0];
    if (account) {
      const tokensData = await instance.acquireTokenSilent({
        scopes: ['openid', 'profile', 'offline_access'],
        account,
      });
      sessionStorage.setItem('authToken', tokensData.idToken || '');
      return true;
    }
    return false;
  } catch (msalError) {
    if (msalError instanceof InteractionRequiredAuthError) {
      instance.acquireTokenRedirect({
        scopes: ['openid', 'profile', 'offline_access'],
        domainHint: process.env.DOMAIN_HINT,
      });
      return false;
    } else {
      console.info('MSAL Silent Error:', msalError);
      return false;
    }
  }
};
